module.exports = __webpack_public_path__ + "media/errors/404-wise-n-heimer-13454f91.gif";